import React from 'react';

// Shared by the home page and the role dashboards (RoleToolCards).

export const CARD_SURFACE = 'bg-white rounded-2xl shadow-md ring-1 ring-black/5 w-full h-full';

export const CardIcon = ({ icon: Icon }) => (
  <div className="shrink-0 w-12 h-12 sm:w-auto sm:h-auto sm:mb-3 rounded-xl sm:rounded-none bg-red-50 sm:bg-transparent text-stanford-red flex items-center justify-center">
    <Icon className="w-6 h-6 sm:w-11 sm:h-11" aria-hidden="true" />
  </div>
);

// A tile that opens a page. A real button, so it is reachable by keyboard and
// announced as actionable. Icon beside the text on phones (a stack of tall
// centred cards pushed everything below the fold); centred column from sm up.
export const HomeCard = ({ icon, title, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className={`${CARD_SURFACE} group p-4 sm:p-6 text-left flex sm:flex-col sm:justify-center items-center gap-4 sm:gap-0 cursor-pointer
      hover:shadow-xl hover:ring-stanford-red/20 sm:hover:-translate-y-0.5 active:scale-[0.99] transition-all duration-200
      focus:outline-none focus-visible:ring-2 focus-visible:ring-stanford-red focus-visible:ring-offset-2`}
  >
    <CardIcon icon={icon} />
    <div className="min-w-0 flex-1 sm:flex-none sm:text-center">
      <h2 className="text-lg font-bold text-gray-800 sm:mb-1">{title}</h2>
      {children}
    </div>
    <svg className="sm:hidden shrink-0 w-5 h-5 text-gray-400 group-hover:text-stanford-red" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  </button>
);

// In the page flow, not fixed: fixed, it covered the last cards on a phone.
// The extra bottom padding on phones clears the test-environment chrome.
export const SiteFooter = () => (
  <footer className="bg-stanford-dark text-white py-4 pb-14 md:pb-4">
    <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
      <p className="text-sm">Stanford Seed Expense Claim System</p>
      <div className="flex gap-6 mt-2 md:mt-0">
        <a href="/help" className="text-sm text-gray-300 hover:text-white transition-colors">Help</a>
        <a href="/contact" className="text-sm text-gray-300 hover:text-white transition-colors">Contact</a>
        <a href="/policy" className="text-sm text-gray-300 hover:text-white transition-colors">Policy</a>
      </div>
    </div>
  </footer>
);
